import normalise from '~/lib/normalizeStr';

export function localSource(props, query) {
    query = query ? query : '';

    const matches = (value, query) => {
        value = normalise(value);
        query = normalise(query);

        const { suggestionMatch, minQueryLength } = props;

        if(!minQueryLength && !query.length) { return true; }
        if(minQueryLength > query.length) { return false; }

        if (suggestionMatch === 'disabled') {
            return true;
        } else if (suggestionMatch === 'start') {
            return value.startsWith(query);
        } else if (suggestionMatch === 'anywhere') {
            return value.includes(query);
        } else if (suggestionMatch === 'word') {
            const re = new RegExp(`\\b${query}`, 'g');
            return re.test(value);
        }else if(suggestionMatch === 'none'){
            return value
        }

        return false;
    };

    let filteredSource = props.options.filter((option) => {
        if(props.multiSelect && props.value.indexOf(option.value) > -1) {
            return true;
        } else if(props.value === option.value) {
            return true;
        }

        return matches(option.text, query);
    });

    return filteredSource;
}